<!-- src/components/GlobalLoading.vue -->
<template>
  <div v-if="visible" class="loading flexCC font20">
    <i class="iconfont icon-loading"></i>
    <p class="text-white">请稍候，资源加载中...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false, // 控制 Loading 的显示与隐藏
    };
  },
};
</script>

<style lang="scss" scoped>
.loading {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba($color: #000, $alpha: 0.95);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;

  > i {
    overflow: hidden;
    margin: 0 1rem 0 0;
    color: #fff;
    animation: rotate360 linear 1.5s infinite;
  }
}
</style>